import { GameState }    from '../../core/GameState.js';
import { renderContractCards, bindContractCardHandlers } from './contractCards.js';

/**
 * Contracts tab: available, active, completed lists.
 */
export class ContractPanel {
  constructor(uiManager) {
    this.ui = uiManager;
    this._sort = 'payment'; // payment | teu | distance | deadline
    this._activeTab = 'available';
  }

  render() {
    const container = document.querySelector('.panel-content');
    container.innerHTML = `
      <div class="contract-tabs">
        <button class="ctab${this._activeTab === 'available' ? ' active' : ''}" data-ctab="available">Available</button>
        <button class="ctab${this._activeTab === 'active' ? ' active' : ''}"    data-ctab="active">Active</button>
        <button class="ctab${this._activeTab === 'completed' ? ' active' : ''}" data-ctab="completed">Completed</button>
      </div>
      <div class="contract-list"></div>`;

    container.querySelectorAll('.ctab').forEach(btn => {
      btn.addEventListener('click', () => {
        container.querySelectorAll('.ctab').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        this._activeTab = btn.dataset.ctab;
        this._renderList(btn.dataset.ctab);
      });
    });

    this._renderList(this._activeTab);
  }

  _renderList(tab) {
    const list = document.querySelector('.contract-list');
    let items = [...(GameState.contracts[tab] || [])];

    if (items.length === 0) {
      list.innerHTML = '<p class="panel-empty">No contracts.</p>';
      return;
    }

    // Sort (available tab only)
    if (tab === 'available') {
      items = this._sortContracts(items);
    }

    // Build sort controls for available tab
    const sortHtml = tab === 'available' ? `
      <div class="contract-sort">
        <label>Sort:</label>
        <select id="contract-sort-select">
          <option value="payment"${this._sort === 'payment' ? ' selected' : ''}>Payment</option>
          <option value="teu"${this._sort === 'teu' ? ' selected' : ''}>TEU (smallest)</option>
          <option value="distance"${this._sort === 'distance' ? ' selected' : ''}>Distance</option>
          <option value="deadline"${this._sort === 'deadline' ? ' selected' : ''}>Deadline</option>
        </select>
      </div>` : '';

    list.innerHTML = sortHtml + renderContractCards(items, tab);

    // Sort control handler
    const sortSelect = list.querySelector('#contract-sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        this._sort = sortSelect.value;
        this._renderList(tab);
      });
    }

    bindContractCardHandlers(list, () => this.render());
  }

  _sortContracts(items) {
    switch (this._sort) {
      case 'payment':
        return items.sort((a, b) => b.payment - a.payment);
      case 'teu':
        return items.sort((a, b) => a.quantity - b.quantity);
      case 'distance':
        return items.sort((a, b) => a.calculateDistance() - b.calculateDistance());
      case 'deadline':
        return items.sort((a, b) => {
          const da = a.deadline ? new Date(a.deadline).getTime() : Infinity;
          const db = b.deadline ? new Date(b.deadline).getTime() : Infinity;
          return da - db;
        });
      default:
        return items;
    }
  }
}
